import React from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import DashboardFormSection
  from 'components/dashboard/common/DashboardFormSection';
import CommonTabList from 'components/common/tabs/CommonTabList';
import CommonTabItem from 'components/common/tabs/CommonTabItem';
import ShopifyIntegrationContent
  from 'components/dashboard/integrations/shopify/ShopifyIntegrationContent';

import './IntegrationsPageContent.css';

const IntegrationsPageContent = ({ integration }) => (
  <Translation>
    {(t) => (
      <div className="integrations-page-content__component">
        <DashboardFormSection header={t("INTEGRATIONS")}>
          <CommonTabList>
            <CommonTabItem
              active={integration === 'shopify'}
              tabName="Shopify"
              url="/integrations/shopify"
            />
            {/*<CommonTabItem*/}
            {/*  active={integration === 'bigcommerce'}*/}
            {/*  tabName="Bigcommerce"*/}
            {/*  url="/integrations/bigcommerce"*/}
            {/*/>*/}
            {/*<CommonTabItem*/}
            {/*  active={integration === 'woocommerce'}*/}
            {/*  tabName="WooCommerce"*/}
            {/*  url="/integrations/woocommerce"*/}
            {/*/>*/}
          </CommonTabList>

          <div className="content-wrapper">
            {integration === 'shopify' &&
              <ShopifyIntegrationContent />
            }
          </div>
        </DashboardFormSection>
      </div>
    )}
  </Translation>
);

IntegrationsPageContent.propTypes = {
  integration: PropTypes.string.isRequired,
};

export default IntegrationsPageContent;
